package com.tregz.tremenz.ui.screen

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.tregz.tremenz.ui.area.nextTabExpanded
import com.tregz.tremenz.ui.label.LabelKey
import com.tregz.tremenz.ui.label.labelText
import com.tregz.tremenz.ui.theme.OxaniumFamily
import com.tregz.tremenz.ui.page.PageAbout
import com.tregz.tremenz.ui.page.PageContact
import com.tregz.tremenz.ui.page.PageNews
import com.tregz.tremenz.ui.page.PagePhotos

/**
 * The Web shell's News / Photos / Contact / About tabs.
 *
 * On a viewport too short for the tab to be readable under the player, [isConstrained] is true and
 * a tab click reports through [onExpandedChange] so the shell can lift the whole pane over the
 * player — see [nextTabExpanded].
 */
@Composable
fun ScreenSite(
    onOpenLink: (String) -> Unit,
    isConstrained: Boolean = false,
    isExpanded: Boolean = false,
    onExpandedChange: (Boolean) -> Unit = {},
    modifier: Modifier = Modifier
) {
    var selectedTabIndex by rememberSaveable { mutableStateOf(0) }
    val tabs = listOf(
        labelText(LabelKey.ROUTE_NEWS),
        labelText(LabelKey.ROUTE_PHOTOS),
        labelText(LabelKey.ROUTE_CONTACT),
        labelText(LabelKey.ROUTE_ABOUT)
    )

    Column(modifier = modifier.fillMaxSize()) {
        PrimaryScrollableTabRow(
            selectedTabIndex = selectedTabIndex,
            modifier = Modifier.fillMaxWidth(),
            edgePadding = 16.dp
        ) {
            tabs.forEachIndexed { index, title ->
                Tab(
                    selected = selectedTabIndex == index,
                    onClick = {
                        onExpandedChange(
                            nextTabExpanded(
                                canExpand = isConstrained,
                                isExpanded = isExpanded,
                                isSameTab = selectedTabIndex == index
                            )
                        )
                        selectedTabIndex = index
                    },
                    text = {
                        Text(
                            text = title,
                            fontFamily = OxaniumFamily,
                            fontWeight = if (selectedTabIndex == index) FontWeight.Bold else FontWeight.Medium
                        )
                    }
                )
            }
        }

        // Capped and centered so web paragraphs keep a readable line length on wide windows.
        val pageModifier = Modifier.weight(1f).widthIn(max = 840.dp).align(Alignment.CenterHorizontally)
        when (selectedTabIndex) {
            0 -> PageNews(modifier = pageModifier)
            1 -> PagePhotos(onOpenLink = onOpenLink, modifier = pageModifier)
            2 -> PageContact(onOpenLink = onOpenLink, modifier = pageModifier)
            3 -> PageAbout(onOpenLink = onOpenLink, modifier = pageModifier)
        }
    }
}
